import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import FormFieldComponent from '@/components/FormFieldComponent';
import FormFieldTextArea from '@/components/FormFieldTextArea';
import { type HiAttemptFormValues } from '../hiAttempt.schema';

const DISABLED_STYLE = 'disabled:opacity-100 text-black bg-[#F5F5F5]';

type Props = {
  workOrder: {
    server?: { firstName: string; lastName: string } | null;
  };
  readOnly?: boolean;
};

export const HiAttemptStep4Comments = ({ workOrder, readOnly }: Props) => {
  const { control, setValue } = useFormContext<HiAttemptFormValues>();

  const inspectorName = workOrder.server
    ? `${workOrder.server.firstName} ${workOrder.server.lastName}`
    : '';

  useEffect(() => {
    setValue('inspectorName', inspectorName || 'No inspector assigned', { shouldValidate: true });
  }, [inspectorName, setValue]);

  return (
    <div className="flex flex-col w-full mt-11 gap-6">
      <div className="w-full text-black">
        <FormFieldTextArea<HiAttemptFormValues>
          name="comments"
          label="Comments"
          placeholder="Enter comments (special characters allowed, emojis not allowed)"
          rows={4}
          disabled={readOnly}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-black">
        <FormFieldComponent
          control={control}
          name="inspectorName"
          label="Inspector (Server) Name"
          placeholder="No inspector assigned"
          required
          disabled
          disabledStyle={DISABLED_STYLE}
        />
      </div>
    </div>
  );
};
